import React, { Component } from 'react'

import SearchBar from './components/SearchBar'
import SearchResults from './components/SearchResults'

import './style.scss'

export default class SearchContent extends Component {
    render() {
        return (
            <div className={'entity-stack-search'}>
                <SearchBar />

                <SearchResults />
            </div>
        )
    }
}
